import Vue from "vue";

import {
  getDashboardElements,
  addDashboardElement,
  deleteDashboardElement,
  reorderDashboardElements
} from "@/api";
//
export default {
  namespaced: true,

  state: {
    dashboardElements: {},
    page: 1,
    limit: 5,
    sort: "-_id",
    loading: true
  },

  mutations: {
    setDashboardElements(state, dashboardElements) {
      state.dashboardElements = dashboardElements;
    },
    setPage(state, page) {
      state.page = page;
    },
    setSort(state, sort) {
      state.sort = sort;
    },
    setLimit(state, limit) {
      state.limit = limit;
    },
    setLoading(state, loading) {
      state.loading = loading;
    }
  },

  actions: {
    async getDashboardElements(store, payload = {}) {
      store.commit("setLoading", true);
      try {
        const resp = await getDashboardElements({
          pagination: false
        });
        if (resp.data.status) {
          const res = {
            ...resp.data.result,
            docs: resp.data.result.docs.map(doc => {
              return {
                ...doc,
                isNew: doc._id === payload.newId
              };
            })
          };
          store.commit("setDashboardElements", res);
          return resp.data.result;
        }
        throw new Error("Не удалось получить элементы рабочего стола");
      } finally {
        store.commit("setLoading", false);
      }
    },
    async goToPage(store, payload) {
      if (
        payload.page &&
        store.state.dashboardElements.totalPages &&
        store.state.dashboardElements.totalPages >= payload.page
      ) {
        store.commit("setPage", payload.page);
        await store.dispatch("getDashboardElements");
      }
    },
    async changeSorting(store, payload) {
      if (payload.sort !== undefined) {
        store.commit("setSort", payload.sort);
        await store.dispatch("getDashboardElements");
      }
    },
    async addDashboardElement(store, balanceAccount) {
      const resp = await addDashboardElement(balanceAccount);
      if (resp.data.status) {
        await store.dispatch("getDashboardElements", {
          newId: resp.data.result._id
        });
        return resp;
      }
    },
    async deleteDashboardElement(store, id) {
      const resp = await deleteDashboardElement(id);
      if (resp.data.status) {
        await store.dispatch("getDashboardElements");
        return resp;
      }
    },
    async reorderDashboardElements(store, ids) {
      const resp = await reorderDashboardElements(ids);
      if (resp.data.status) {
        await store.dispatch("getDashboardElements");
        return resp;
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/ledgerDashboards.js